import EaListing from '@propertypal/shared/src/resources/icons/products/ea-listing-icon.svg';
import ListingMockup2 from '@propertypal/shared/src/resources/images/listing-a-property/ea-listing-pdp-mockup.png';
import ListingMockup1 from '@propertypal/shared/src/resources/images/listing-a-property/ea-listing.png';
import platform from '@propertypal/shared/src/utils/platform';
import ProductsPageHeader from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import { Box } from '@propertypal/web-ui/src/layout';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs from '@propertypal/web-ui/src/products/ProductScreenTabs';
import { Text, TextLink } from '@propertypal/web-ui/src/typography';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const PRODUCTS_URL = '/products/estate-agents';

const metaData = {
  title: `Listing a Property - ${platform.title}`,
  description: "List Your Property On Northern Ireland's Largest Property Website.",
  url: `/products/estate-agents/listing-a-property`,
};

const ListingAProperty = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Listing a Property"
        text="List your property on Northern Ireland's largest property website."
        icon={<EaListing />}
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 700, mb: 20 }}
        maxW={1440}
      >
        <ProductScreenTabs
          aspectRatio="268 / 223"
          reverse
          mockup={{
            src: ListingMockup1.src,
            alt: 'Listing a Property',
          }}
          mockupWidth={500}
          maxW={1050}
          tabsMt={0}
          breakpoint={1200}
          content={
            <Box maxWidth={420}>
              <Text mb={20} lineHeight={25} align="left">
                At PropertyPal, we understand that every estate agent has unique needs when it comes to listing
                properties. That&apos;s why we offer flexible advertising solutions designed to fit your business model
                seamlessly.
              </Text>
              <Text mb={20} lineHeight={25} align="left">
                Choose from our tiered plans or opt for our Pay Per Listing model. Whether you prefer paying for what
                you list or a flat fee for streamlined planning, we have a plan that suits you. With PropertyPal,
                you&apos;re in control of how you manage your listings and your budget.
              </Text>
              <Text lineHeight={25} align="left">
                Streamline your listing process with our comprehensive integrations with leading Estate Agent CRM
                systems. Enjoy automated feeds that save you time and effort, and control where your listings are fed to
                for maximum exposure and efficiency.
              </Text>
            </Box>
          }
          staticTabs
        />
        <ProductScreenTabs
          aspectRatio="247 / 149"
          mockupWidth={630}
          tabsMt={0}
          tabPadding={80}
          maxW={1440}
          button={{
            onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
            text: 'Contact us',
            containerStyle: { maxWidth: '280px', marginTop: 0 },
          }}
          buttonMt={0}
          mockup={{
            src: ListingMockup2.src,
            alt: 'Listing a Property',
          }}
          breakpoint={1200}
          content={
            <Box maxWidth={420}>
              <Text mb={20} lineHeight={25} align="left">
                Showcase your property advert using a comprehensive media section including photos, virtual tours,
                videos, floor plans, maps. We complement your advert with government issued rates data, broadband
                speeds, typical mortgage costs & stamp duty costs as standard. PropertyPal will notify users of new and
                updated adverts with a saved search criteria matching your property advert.
              </Text>
              <Text mb={20} lineHeight={25} align="left">
                Promote your property on the search results with a{' '}
                <TextLink href={`${PRODUCTS_URL}/featured-listing`} prefetch={false} display="inline-flex">
                  Featured
                </TextLink>{' '}
                or{' '}
                <TextLink href={`${PRODUCTS_URL}/premier-listing`} prefetch={false} display="inline-flex">
                  Premier
                </TextLink>{' '}
                Listing and provide Mortgage leads to your financial services partner using our embedded
                <TextLink href={`${PRODUCTS_URL}/broker-calculator`} prefetch={false} display="inline-flex">
                  Mortgage Broker advert
                </TextLink>
                . With our tiered plans, your adverts also benefit from enhanced branding and &apos;Request a
                Valuation&apos;.
              </Text>
              <Text fontWeight="bold" lineHeight={25} align="left">
                To find out more or to list with us, contact us today.
              </Text>
            </Box>
          }
          staticTabs
        />
      </ProductsPageHeader>
      <ProductsContact reason="Listing a Property" />
    </>
  );
};

export default ListingAProperty;
